import React from 'react'

export default function UnorderedList() {
    return (
        <svg
            height='100%'
            viewBox='0 0 36 36'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M12 6H31.5V9H12V6ZM6.75 9.75C6.15326 9.75 5.58097 9.51295 5.15901 9.09099C4.73705 8.66903 4.5 8.09674 4.5 7.5C4.5 6.90326 4.73705 6.33097 5.15901 5.90901C5.58097 5.48705 6.15326 5.25 6.75 5.25C7.34674 5.25 7.91903 5.48705 8.34099 5.90901C8.76295 6.33097 9 6.90326 9 7.5C9 8.09674 8.76295 8.66903 8.34099 9.09099C7.91903 9.51295 7.34674 9.75 6.75 9.75ZM6.75 20.25C6.15326 20.25 5.58097 20.0129 5.15901 19.591C4.73705 19.169 4.5 18.5967 4.5 18C4.5 17.4033 4.73705 16.831 5.15901 16.409C5.58097 15.9871 6.15326 15.75 6.75 15.75C7.34674 15.75 7.91903 15.9871 8.34099 16.409C8.76295 16.831 9 17.4033 9 18C9 18.5967 8.76295 19.169 8.34099 19.591C7.91903 20.0129 7.34674 20.25 6.75 20.25ZM6.75 30.6C6.15326 30.6 5.58097 30.3629 5.15901 29.941C4.73705 29.519 4.5 28.9467 4.5 28.35C4.5 27.7533 4.73705 27.181 5.15901 26.759C5.58097 26.3371 6.15326 26.1 6.75 26.1C7.34674 26.1 7.91903 26.3371 8.34099 26.759C8.76295 27.181 9 27.7533 9 28.35C9 28.9467 8.76295 29.519 8.34099 29.941C7.91903 30.3629 7.34674 30.6 6.75 30.6ZM12 16.5H31.5V19.5H12V16.5ZM12 27H31.5V30H12V27Z'
                fill='black'
            />
        </svg>
    )
}
